<template>
  <div class="pcBatteryBox">
    <Goback :title="'返回'" style="position: absolute;left: 20%;top:0;z-index: 10;"></Goback>
    <batteryBox v-show="showBatteryBox" @changeParentShow="changeParentShow" style="transform:scale(0.7)"/>
    <batteryBag v-show="!showBatteryBox" @changeParentShow="changeParentShow" style="transform:scale(0.75)"/>
    <Overview class="pcbatteryBoxL" :batteryInfo="batteryInfo"/>
    <div class="flex flex-direction pcbatteryBoxR">
      <SiteType :batteryInfo="batteryInfo"/>
    </div>
  </div>
</template>

<script>
//综合态势
import Goback from "@/components/goBack.vue";
import Overview from "@/views/pcbatteryBox/overview.vue";
import batteryBox from "@/views/batteryBox/batteryBox";
import batteryBag from "@/views/batteryBox/batteryBag";
import SiteType from "@/views/pcbatteryBox/siteType.vue";

import { batteryBoxLeft } from '@/api/batteryBox/left';

export default {
  data () {
    return {
      batteryInfo:{},
      showBatteryBox:true,
    };
  },
  components: {
    Overview,
    batteryBox,
    SiteType,
    batteryBag,
    Goback
  },
  props: {
    
  },
  watch: {
    
  },
  mounted () {
    // 0  乘用车  1 商用车
    this.showBatteryBox = this.$route.query.vehicleClassification*1===1?true:false;
  },
  methods: {
    getData(data){
      // this.centerBatterInfo(data)
    },
    // centerBatterInfo(data={}){
    //   let _this = this;
    //   batteryBoxLeft
    //     .centerBatterInfo(data)
    //     .then((res) => {
    //       if(!res) return;
    //       _this.batteryInfo = res;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    //控制电池箱、电池包显示隐藏
    changeParentShow(){
      console.log(this.showBatteryBox,'showBatteryBox')
      this.showBatteryBox = !this.showBatteryBox;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
</style>